// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React from 'react';
import styled from 'styled-components';

const S = {
  PopMask: styled.div`
    background: #FFFFFF;
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0px;
    top: 0px;
    background: rgba(0, 0, 0, 0.7);
    z-index: 9999;
  `,
  ZoomInImg: styled.img`
    position: absolute;
    top: 55%;
    left: 50%;
    transform: scale(1.2,1.2) translate(-36%, -50%);
  `,
}

const ImgPopUp = (props: any): JSX.Element => {
  const setShowImgUp = props.setShowImgUp;

  return (
    <>
      { props.showImgUp ?
        <S.PopMask onClick={() => setShowImgUp(false)}>
          <S.ZoomInImg alt="exam-img" src={props.img} />
        </S.PopMask>
        : null }
    </>
  )
}

export default ImgPopUp;
